<template>
    <div>
      <!--form表单-->
      <el-form size="small" ref="formData" :model="formData" label-width="150px">
        <el-form-item label="客服类型">
          <div>
            <el-radio v-model="formData.service_type" :label="10">聊天工具</el-radio>
            <el-radio v-model="formData.service_type" :label="20" v-if="formData.service_open==1">在线客服</el-radio>
          </div>
        </el-form-item>
        <div v-if="formData.service_type==10">
        <el-form-item label="微信号">
          <el-input v-model="formData.wechat" placeholder="请输入微信号" class="max-w460"></el-input>
        </el-form-item>
        <el-form-item label="qq">
          <el-input v-model="formData.qq" placeholder="请输入qq号" class="max-w460"></el-input>
        </el-form-item>
        <el-form-item label="联系电话">
          <el-input v-model="formData.phone" placeholder="请输入联系电话" class="max-w460"></el-input>
        </el-form-item>
        </div>
        <el-form-item label="绑定客服" v-if="formData.service_type==20" :rules="[{required: true,message: '请输入绑定用户id'}]" prop="user_id">
          <el-input type="number" v-model="formData.user_id" placeholder="请输入用户id" class="max-w460" :disabled="user_id>0"></el-input>
          <p class="gray">请在商城小程序个人中心查看用户ID</p>
        </el-form-item>
        <!--提交-->
        <div class="common-button-wrapper">
          <el-button size="small" type="primary" @click="onSubmit" :disabled="loading">提交</el-button>
        </div>
      </el-form>
    </div>
  </template>

  <script>
    import SettingApi from '@/api/setting.js';
    export default{
      data(){
        return {
          /*是否在提交*/
          loading:false,
          /*表单数据对象*/
          formData:{
            service_type: 10,
            wechat:'',
            qq:'',
            phone:'',
            service_open:'',
            user_id:''
          },
          user_id:0
        }
      },
      created() {
        this.getData();
      },
      methods:{
        /*获取配置数据*/
        getData() {
          let self = this;
          SettingApi.getService({}, true).then(res => {
              if(res.data.model != null){
                self.formData = res.data.model;
                self.user_id = res.data.model.user_id;
              }
            })
            .catch(error => {

            });
        },

        /*提交*/
        onSubmit() {
          let self = this;
          let params = this.formData;
          self.$refs.formData.validate((valid) => {
            if (valid) {
              self.loading = true;
              SettingApi.setService(params, true)
                .then(data => {
                  self.loading = false;
                  self.$message({
                    message: '恭喜你，保存设置成功',
                    type: 'success'
                  });
                })
                .catch(error => {
                  self.loading = false;
                });
            }
          });
        },
      }
    }
  </script>

  <style>
  </style>



// WEBPACK FOOTER //
// src/views/setting/service/index.vue